import { render, staticRenderFns } from "./cert-autor-verify.vue?vue&type=template&id=4668cd42&scoped=true&"
import script from "./cert-autor-verify.vue?vue&type=script&lang=js&"
export * from "./cert-autor-verify.vue?vue&type=script&lang=js&"
import style0 from "./cert-autor-verify.vue?vue&type=style&index=0&lang=less&"
import style1 from "./cert-autor-verify.vue?vue&type=style&index=1&id=4668cd42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668cd42",
  null
  
)

export default component.exports